import { useEffect, useState } from 'react';

export function useOpenOnce(
    isReady: boolean,
    open: () => void | Promise<void>,
): void {
    const [hasOpened, setHasOpened] = useState(false);

    useEffect(() => {
        if (isReady && !hasOpened) {
            setHasOpened(true);
            void open();
        }
    }, [isReady, hasOpened, open]);
}
